import * as React from "react";
import SidebarItem from "../../Generics/SidebarItem";
import RemeasureIcon from "../../icons/RemeasureIcon";
import { getCorruptedIconColors } from "../../../redux/computables/flightMarkerIcon/flightMarkerIcon";
import { faintBlue } from "../../Generics/_colors";
import { White } from "@traceair/tds";
import { IFlightMarker } from "../../../apiFacades/bapi/flightMarkers";
import { stylesheet } from "typestyle";
import { CorruptedGcpType } from "../../../apiFacades/bapi/gcpRequests";
import { AnnotatableIconContainer } from "./AnnotatableIconContainer";
import { GcpSidebarIcon } from "../../../redux/computables/flightMarkerIcon/GcpSidebarIcon";

const css = stylesheet({
  subtitle: {
    padding: "0 12px",
  },
});

interface IProps {
  marker: IFlightMarker;
  corruptionType?: CorruptedGcpType;
  onClick: () => void;
  active?: boolean;
  remeasured?: boolean;
}

export const RemeasurableMarkerItem: React.FC<IProps> = (props) => {
  const { marker, corruptionType, remeasured, active, onClick } = props;
  return (
    <SidebarItem
      leftIcon={
        <AnnotatableIconContainer
          icon={<GcpSidebarIcon type="gcp" corruptionType={corruptionType} />}
          annotationIcon={
            remeasured && (
              <RemeasureIcon
                color={getCorruptedIconColors(corruptionType).color}
              />
            )
          }
        />
      }
      rightLabel={
        // if we don't have a corruption type item will be rendered into a separate section
        // making this comment redundant
        remeasured && corruptionType ? (
          <span className={css.subtitle}>Remeasure</span>
        ) : null
      }
      leftLabel={marker.name}
      onLeftIconClick={onClick}
      onLeftLabelClick={onClick}
      onRightLabelClick={onClick}
      backgroundColor={active ? faintBlue : White}
    />
  );
};
